module.exports = require('./datahandler.js');


//////////////////
// WEBPACK FOOTER
// ../~/espn-fitt/es5/fitt-datahandler/index.js
// module id = 788
// module chunks = 0